import { render, staticRenderFns } from "./SuppliersGroupView.vue?vue&type=template&id=0e22e553&scoped=true&"
import script from "./SuppliersGroupView.vue?vue&type=script&lang=js&"
export * from "./SuppliersGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22e553",
  null
  
)

export default component.exports